import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceActionsQueuePage from "@/pages/admin/PerformanceActionsQueuePage";

export const Route = createFileRoute("/_admin/admin/performance/actions")({
  head: () => pageHead("Admin · Performance · Actions", "AKIVA admin · performance · actions portal.", "/admin/performance/actions", true),
  component: PerformanceActionsQueuePage,
});
